const translations: Record<string, string> = {
  "ak_docsdata_legislation": "Законодавство",
  "ak_docsdata_on_the_electricity_market": "Про ринок електричної енергії",
  "ak_docsdata_law_of_ukraine": "Закон України",
  "ak_docsdata_on_alternative_energy_sources": "Про альтернативні джерела енергії",
  "ak_docsdata_on_amendments_to_improve_the_support_c": "Про внесення змін щодо удосконалення умов підтримки виробництва електричної енергії з альтернативних джерел",
  "ak_docsdata_law_of_ukraine_no_810_ix": "Закон України № 810-IX",
  "ak_docsdata_on_prevention_of_abuse_in_wholesale_en": "Про запобігання зловживанням на оптових енергетичних ринках (REMIT)",
  "ak_docsdata_law_of_ukraine_no_3141_ix": "Закон України № 3141-IX",
  "ak_docsdata_on_the_recovery_and_green_transformati": "Про відновлення та «зелену» трансформацію енергетичної системи України",
  "ak_docsdata_law_of_ukraine_no_3220_ix": "Закон України № 3220-IX",
  "ak_docsdata_licensing": "Ліцензування",
  "ak_docsdata_licensing_conditions_for_conducting_bu": "Ліцензійні умови провадження господарської діяльності з виробництва електричної енергії",
  "ak_docsdata_neurc_resolution_of_27_12_2017_no_1467": "Постанова НКРЕКП від 27.12.2017 № 1467",
  "ak_docsdata_licensing_conditions_for_conducting_bu_2": "Ліцензійні умови провадження господарської діяльності зі зберігання енергії",
  "ak_docsdata_neurc_resolution_of_22_07_2022_no_798": "Постанова НКРЕКП від 22.07.2022 № 798",
  "ak_docsdata_procedure_for_registration_of_wholesal": "Порядок реєстрації учасників оптового енергетичного ринку",
  "ak_docsdata_neurc_resolution_of_04_10_2023_no_1812": "Постанова НКРЕКП від 04.10.2023 № 1812",
  "ak_docsdata_grid_connection": "Приєднання до мереж",
  "ak_docsdata_transmission_system_code": "Кодекс системи передачі",
  "ak_docsdata_neurc_resolution_of_14_03_2018_no_309": "Постанова НКРЕКП від 14.03.2018 № 309",
  "ak_docsdata_distribution_system_code": "Кодекс систем розподілу",
  "ak_docsdata_neurc_resolution_of_14_03_2018_no_310": "Постанова НКРЕКП від 14.03.2018 № 310",
  "ak_docsdata_metering": "Облік",
  "ak_docsdata_electricity_commercial_metering_code": "Кодекс комерційного обліку електричної енергії",
  "ak_docsdata_neurc_resolution_of_14_03_2018_no_311": "Постанова НКРЕКП від 14.03.2018 № 311",
  "ak_docsdata_market": "Ринок",
  "ak_docsdata_market_rules": "Правила ринку",
  "ak_docsdata_neurc_resolution_of_14_03_2018_no_307": "Постанова НКРЕКП від 14.03.2018 № 307",
  "ak_docsdata_rules_of_the_day_ahead_and_intraday_ma": "Правила ринку «на добу наперед» та внутрішньодобового ринку",
  "ak_docsdata_neurc_resolution_of_14_03_2018_no_308": "Постанова НКРЕКП від 14.03.2018 № 308",
  "ak_docsdata_retail_electricity_market_rules": "Правила роздрібного ринку електричної енергії",
  "ak_docsdata_neurc_resolution_of_14_03_2018_no_312": "Постанова НКРЕКП від 14.03.2018 № 312",
  "ak_docsdata_reporting": "Звітність",
  "ak_docsdata_monitoring_reporting_forms_for_market": "Форми звітності з моніторингу для учасників ринку (1В, 2, 3, 4В)",
  "ak_docsdata_neurc_resolution_of_29_03_2019_no_450": "Постанова НКРЕКП від 29.03.2019 № 450",
  "ak_docsdata_neurc_reporting_forms_for_market_parti": "Форми звітності НКРЕКП для учасників ринку (4 і 4а)",
  "ak_docsdata_neurc_resolution_of_28_02_2019_no_282": "Постанова НКРЕКП від 28.02.2019 № 282",
  "ak_docsdata_green_tariff": "Зелений тариф",
  "ak_docsdata_procedure_for_purchase_by_the_guarante": "Порядок купівлі гарантованим покупцем електричної енергії, виробленої з альтернативних джерел",
  "ak_docsdata_neurc_resolution_of_26_04_2019_no_641": "Постанова НКРЕКП від 26.04.2019 № 641",
  "ak_docsdata_operation": "Експлуатація",
  "ak_docsdata_rules_for_safe_operation_of_consumers": "Правила безпечної експлуатації електроустановок споживачів",
  "ak_docsdata_order_of_the_state_committee_for_occup": "Наказ Держнаглядохоронпраці від 09.01.1998 № 4",
  "ak_docsdata_rules_for_technical_operation_of_consu": "Правила технічної експлуатації електроустановок споживачів",
  "ak_docsdata_order_of_the_ministry_of_fuel_and_ener": "Наказ Мінпаливенерго від 25.07.2006 № 258",
  "ak_docsdata_procedure_for_investigation_and_record": "Порядок розслідування та обліку нещасних випадків, професійних захворювань та аварій на виробництві",
  "ak_docsdata_resolution_of_the_cabinet_of_ministers": "Постанова КМУ від 17.04.2019 № 337",
  "ak_docsdata_instruction_on_recording_and_investiga": "Інструкція з обліку та розслідування технологічних порушень у роботі енергетичного господарства споживачів",
  "ak_docsdata_order_of_the_ministry_of_fuel_and_ener_2": "Наказ Мінпаливенерго від 04.08.2006 № 270",
  "ak_docsdata_npc_ukrenergo_tso": "НЕК «Укренерго» (ОСП)",
  "ak_docsdata_on_the_provision_of_electricity_transm": "Про надання послуг з передачі електричної енергії",
  "ak_docsdata_npc_ukrenergo_notification": "повідомлення НЕК «Укренерго»",
  "ak_docsdata_on_the_provision_of_dispatch_operation": "Про надання послуг з диспетчерського (оперативно-технологічного) управління",
  "ak_docsdata_on_the_settlement_of_electricity_imbal": "Про врегулювання небалансів електричної енергії",
  "ak_docsdata_on_participation_in_the_balancing_mark": "Про участь у балансуючому ринку",
  "ak_docsdata_zakarpattiaoblenergo_pjsc_dso": "ПРАТ «ЗАКАРПАТТЯОБЛЕНЕРГО» (ОСР)",
  "ak_docsdata_on_non_standard_connection": "Про нестандартне приєднання",
  "ak_docsdata_consumer_on_the_provision_of_electrici": "Споживача про надання послуг з розподілу е/е",
  "ak_docsdata_on_the_provision_of_services_for_ensur": "Про надання послуг із забезпечення перетікань реактивної електричної енергії",
  "ak_docsdata_with_a_producer_on_the_provision_of_el": "З виробником про надання послуг з розподілу е/е",
  "ak_docsdata_helios_aggregator_llc": "ТОВ «ГЕЛІОС АГРЕГАТОР»",
  "ak_docsdata_on_participation_in_a_balancing_group": "Про участь у балансуючій групі / агрегованій групі",
  "ak_docsdata_on_granting_the_right_to_use_the_helio": "Про надання права використання автоматизованої системи Helios EMS",
  "ak_docsdata_tepla_llc": "ТОВ «ТЕПЛА»",
  "ak_docsdata_electricity_purchase_and_sale": "Купівлі-продажу електричної енергії",
  "ak_docsdata_electricity_supply_for_own_needs": "Постачання е/е для власних потреб",
  "ak_docsdata_not_applicable": "не застосовується",
  "ak_docsdata_helios_strategia_llc": "ТОВ «ГЕЛІОС СТРАТЕГІЯ»",
  "ak_docsdata_on_the_provision_of_technical_maintena": "Про надання послуг з технічного обслуговування",
  "ak_docsdata_scan_without_a_text_layer_date_taken_f": "скан без текстового шару; дата з метаданих файла",
  "ak_docsdata_legion_alfa_security_agency_llc": "ТОВ «Охоронне агентство «Легіон-Альфа»",
  "ak_docsdata_for_stationary_physical_protection_of": "На стаціонарну фізичну охорону об’єктів",
  "ak_docsdata_asek_llc": "ТОВ «АСЕК»",
  "ak_docsdata_for_maintenance_of_the_fire_alarm_syst": "На технічне обслуговування системи пожежної сигналізації",
  "ak_docsdata_other": "Інші",
  "ak_docsdata_on_the_provision_of_communication_it_s": "Про надання послуг зв’язку / IT",
  "ak_docsdata_on_insurance_of_pv_plant_bess_property": "Про страхування майна ФЕС/УЗЕ та перерв у виробництві",
  "ak_docsdata_for_wastewater_disposal_and_water_supp": "На водовідведення та постачання води для потреб СЕС",
  "ak_docsdata_electrical_equipment_testing_metrology": "Випробування електрообладнання, метрологія",
  "ak_docsdata_for_waste_removal": "На вивіз відходів",
  "ak_docsdata_neurc": "НКРЕКП",
  "ak_docsdata_monitoring_reporting": "моніторингова звітність",
  "ak_docsdata_report_on_general_characteristics_of_t": "Звіт про загальну характеристику виробника електричної енергії",
  "ak_docsdata_no_1_neurc_monitoring_generation": "№ 1-НКРЕКП-моніторинг-виробництво",
  "ak_docsdata_annual": "річна",
  "ak_docsdata_report_on_net_income": "Звіт про обсяг чистого доходу",
  "ak_docsdata_no_1_neurc_income": "№ 1-НКРЕКП-дохід",
  "ak_docsdata_quarterly": "квартальна",
  "ak_docsdata_report_on_electricity_purchase_and_sal": "Звіт про купівлю-продаж електричної енергії та наданих послуг",
  "ak_docsdata_no_2_neurc_monitoring_generation": "№ 2-НКРЕКП-моніторинг-виробництво",
  "ak_docsdata_monthly": "місячна",
  "ak_docsdata_report_on_electricity_generation_activ": "Звіт про діяльність з виробництва електричної енергії",
  "ak_docsdata_no_4_neurc_monitoring_generation": "№ 4-НКРЕКП-моніторинг-виробництво",
  "ak_docsdata_report_on_payment_of_the_regulation_fe": "Звіт про сплату внеску на регулювання",
  "ak_docsdata_no_20_neurc": "№ 20-НКРЕКП",
  "ak_docsdata_financial_statements_balance_sheet_sta": "Фінансова звітність: баланс, звіт про фінансові результати",
  "ak_docsdata_neurc_qes": "НКРЕКП (КЕП)",
  "ak_docsdata_quarterly_annual": "квартальна / річна",
  "ak_docsdata_report_on_business_and_trading_transac": "Звіт про господарсько-торговельні операції з оптовими енергетичними продуктами (REMIT)",
  "ak_docsdata_appendix_no_2": "Додаток № 2",
  "ak_docsdata_on_event": "за подією",
  "ak_docsdata_npc_ukrenergo": "НЕК «Укренерго»",
  "ak_docsdata_industry_reporting": "галузева звітність",
  "ak_docsdata_electricity_balance_report": "Звітний баланс електроенергії",
  "ak_docsdata_form_no_37_energo": "Форма № 37-енерго",
  "ak_docsdata_state_statistics_service": "Держстат",
  "ak_docsdata_statistical_reporting": "статистична звітність",
  "ak_docsdata_report_on_energy_supply_and_use": "Звіт про постачання та використання енергії",
  "ak_docsdata_no_11_mtp": "№ 11-мтп",
  "ak_docsdata_report_on_fuel_use_and_stocks": "Звіт про використання та запаси палива",
  "ak_docsdata_no_4_mtp": "№ 4-мтп",
  "ak_docsdata_monthly_annual": "місячна / річна",
  "ak_docsdata_neurc_license": "Ліцензія НКРЕКП",
  "ak_docsdata_neurc_resolution_of_02_06_2026_no_829": "Постанова НКРЕКП від 02.06.2026 № 829",
  "ak_docsdata_technical_conditions_for_non_standard": "Технічні умови нестандартного приєднання до електричних мереж електроустановок",
  "ak_docsdata_npc_ukrenergo_notification_to_the_bala": "Повідомлення НЕК «Укренерго» стороні, відповідальній за баланс, про вхід учасника ринку до балансуючої групи",
  "ak_docsdata_technical_passport": "Технічний паспорт",
  "ak_docsdata_act_of_demarcation_of_balance_sheet_ow": "Акт розмежування балансової належності та експлуатаційної відповідальності",
  "ak_docsdata_main_single_line_diagram_of_electrical": "Головна однолінійна схема електричних з’єднань (погоджена ОСР)",
  "ak_docsdata_single_line_diagram_of_the_metering_de": "Однолінійна схема розташування приладів розрахункового обліку",
  "ak_docsdata_master_plan_with_equipment_list": "Генплан із переліком обладнання",
  "ak_docsdata_askoe_and_communication_channel_diagra": "Схема АСКОЕ і каналів зв’язку",
  "ak_docsdata_tko_list": "Перелік ТКО",
  "ak_docsdata_meter_and_instrument_transformer_passp": "Паспорти лічильників і вимірювальних трансформаторів",
  "ak_docsdata_relay_protection_settings_card_approve": "Картка уставок релейного захисту (погоджена ОСР)",
  "ak_docsdata_main_equipment_specification_with_seri": "Специфікація основного обладнання з серійними номерами",
  "ak_docsdata_apd_services": "Договір на послуги АПД",
  "ak_docsdata_audit_firm": "аудиторська фірма",
  "ak_docsdata_audit_services": "Аудиторські послуги",
  "ak_docsdata_bank": "банківська установа",
  "ak_docsdata_banking_services": "Банківські послуги / РКО",
  "ak_docsdata_charter_signatory_authority": "Статут або інший документ про повноваження підписанта",
  "ak_docsdata_company_services": "Обслуговування компанії",
  "ak_docsdata_contractors_sole_traders": "Підрядники / ФОП",
  "ak_docsdata_csk_other": "ЦСК Україна / інші",
  "ak_docsdata_edo_services": "Послуги електронного документообігу (M.E.Doc / Вчасно)",
  "ak_docsdata_edr_extract": "Витяг з ЄДР",
  "ak_docsdata_ee_heat_balance_tech_econ": "Баланс е/е і теплоенергії та розрахунок техніко-економічних показників",
  "ak_docsdata_electricity_purchase_own_needs": "Про купівлю е/е (власні потреби)",
  "ak_docsdata_energy_supplier_or_tepla": "енергозбут / ТОВ «Тепла»",
  "ak_docsdata_excise_return": "Податкова декларація з акцизного податку",
  "ak_docsdata_financial_statements": "Фінансова звітність",
  "ak_docsdata_form_1_pe": "№ 1-ПЕ",
  "ak_docsdata_form_1_pv": "№ 1-ПВ",
  "ak_docsdata_form_1ms_2ms": "№ 1-мс (баланс), № 2-мс (звіт про фінансові результати)",
  "ak_docsdata_form_no_3": "№ 3",
  "ak_docsdata_helios_ems_connection_act": "Акт підключення об’єкта до HELIOS EMS",
  "ak_docsdata_industry_short_term_stats": "Звіт про економічні показники короткотермінової статистики промисловості",
  "ak_docsdata_labour_report": "Звіт із праці",
  "ak_docsdata_land_fee_return": "Декларація з плати за землю",
  "ak_docsdata_land_lease": "Оренда землі",
  "ak_docsdata_layout_8111": "Макет 8111",
  "ak_docsdata_layout_8112": "Макет 8112",
  "ak_docsdata_market_operator_ueex": "АТ «Оператор ринку» / УЕБ",
  "ak_docsdata_monthly_quarterly": "місячна / квартальна",
  "ak_docsdata_profit_tax_return": "Декларація з податку на прибуток",
  "ak_docsdata_qes_certification": "Сертифікація КЕП / ЕЦП",
  "ak_docsdata_relay_protection_setup": "Налаштування РЗВА",
  "ak_docsdata_tax_reporting": "Податкова звітність",
  "ak_docsdata_tax_service": "ДПС",
  "ak_docsdata_vat_payer_certificate": "Свідоцтво платника ПДВ",
  "ak_docsdata_vat_return": "Податкова декларація з ПДВ",
  "ak_docsdata_vchasno_other": "Вчасно / інші",
  "ak_docsdata_wage_arrears_report": "Звіт про заборгованість з оплати праці",
};

export default translations;
